var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',_vm._b({staticClass:"d-block"},'b-link',_vm.is_external? { href: _vm.link, target: '_blank'}: { to: _vm.link},false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }